import Tracker from '@openreplay/tracker';

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '[::1]';

const projectKey = 'OZ79lY2SdgHna5WtF68a';

let _tracker: Tracker | null = null;

if (!isLocalhost && projectKey) {
  _tracker = new Tracker({
    projectKey,
    network: {
      capturePayload: true,
      captureInIframes: false,
      failuresOnly: false,
      sessionTokenHeader: false,
      ignoreHeaders: ['Authorization'],
    },
  });
  _tracker.start();
}

const tracker = {
  setUserID:   (id: string)                 => { _tracker?.setUserID(id); },
  setMetadata: (key: string, value: string) => { _tracker?.setMetadata(key, value); },
} as const;

export default tracker;
